class NewsletterItem {
  constructor(_id, id, title, description, date, type, downloadLink,active) {
    this._id = _id;
    this.id = id;
    this.title = title;
    this.description = description;
    this.date = date; // may be Date instance or string
    this.type = type;
    this.downloadLink = downloadLink;
    this.active = active;
  }

  static fromJSON(json = {}) {
    const rawDate = json.date || json.publishedAt || "";
    let parsedDate = "";
    if (rawDate) {
      const asNumber = Number(rawDate);
      if (!Number.isNaN(asNumber) && String(rawDate).trim() !== "") {
        // support seconds or milliseconds
        parsedDate = new Date(asNumber < 1e12 ? asNumber * 1000 : asNumber);
      } else {
        const dt = new Date(rawDate);
        parsedDate = isNaN(dt.getTime()) ? rawDate : dt;
      }
    }

    return new NewsletterItem(
      json._id || json.id || null,
      json.id || json._id || null,
      json.title || json.name || "",
      json.description || json.summary || json.excerpt || "",
      parsedDate,
      json.type || json.reportType || "",
      json.downloadLink || json.url || json.link || "",
      !!json.active
    );
  }

  toJSON() {
    return {
      _id: this._id,
      id: this.id,
      title: this.title,
      description: this.description,
      date: this.date ? (this.date instanceof Date ? this.date.toISOString() : this.date) : "",
      type: this.type,
      downloadLink: this.downloadLink,
      active: this.active
    };
  }
}

module.exports = NewsletterItem;
